import { z } from 'zod';

import { MediaTypeEnum } from '../../enums';
import { levelEnumValidator, uuidValidator } from '../../validators';

export const CreateMediaResourceSchema = z.object({
  description: z.string().optional(),
  levels: z.array(levelEnumValidator),
  tagIds: z.array(uuidValidator).optional(),
  thumbnailUrl: z.string().url().optional().nullable(),
  title: z.string().min(1),
  type: z.nativeEnum(MediaTypeEnum),
  url: z.string().url(),
});

export type ICreateMediaResourceDto = z.infer<typeof CreateMediaResourceSchema>;
